module.exports = __webpack_public_path__ + "img/logo-dash.7466e253.png";